// ============================================
// 公共 API - UI 组件
// ============================================
export { RegionSelectorModal } from './RegionSelectorModal.js'
export { RegionBanner } from './RegionBanner.js'
export { RegionSelectorModal as default } from './RegionSelectorModal.js'

// ============================================
// 公共 API - 统一 Hook（推荐使用）
// ============================================
export { useRegionRedirectManager } from './useRegionRedirectManager.js'

// ============================================
// 公共 API - 工具函数
// ============================================
export {
  generateRegionToPathMap,
  isPathInWhitelist,
  validateRegionConfig,
  localeToRegionCode,
  buildGeoRedirectRef,
  buildGeoRedirectRefManual,
} from './utils.js'

// ============================================
// 公共 API - 类型定义
// ============================================
export type { RegionSelectorModalProps, RegionSelectorModalStyles } from './RegionSelectorModal.js'
export type { RegionBannerProps, RegionBannerStyles } from './RegionBanner.js'
export type { UseRegionRedirectManagerOptions, UseRegionRedirectManagerReturn } from './useRegionRedirectManager.js'
export type {
  RegionConfig,
  IPRedirectModalCopy,
  IPRedirectBannerCopy,
  RegionToPathMap,
  CountryToRegionMap,
} from './type.js'
